import { api } from './api';

export interface StudentRequest {
  id: string;
  studentId: string;
  type: string;            // Leave | DressCode | DropChange | Other
  title: string;
  detail: string | null;
  fromDate: string | null;
  toDate: string | null;
  forDate: string | null;
  location: string | null;
  status: string;          // Submitted | Acknowledged | Approved | Declined
  reviewNote: string | null;
  submittedAt: string;
  reviewedAt: string | null;
}

export const requestsApi = {
  // family submit
  leave: (b: { studentId: string; fromDate: string; toDate: string; reason?: string | null }) =>
    api.post<StudentRequest>('/api/portal/requests/leave', b),
  dressCode: (b: { studentId: string; detail: string }) =>
    api.post<StudentRequest>('/api/portal/requests/dress-code', b),
  dropChange: (b: { studentId: string; forDate: string; location: string; reason?: string | null }) =>
    api.post<StudentRequest>('/api/portal/requests/drop-change', b),
  other: (b: { studentId: string; title: string; detail?: string | null }) =>
    api.post<StudentRequest>('/api/portal/requests/other', b),
  mine: (type?: string) => api.get<StudentRequest[]>(`/api/portal/requests/mine${type ? `?type=${type}` : ''}`),

  // staff inbox
  pending: (type?: string) => api.get<StudentRequest[]>(`/api/requests/pending${type ? `?type=${type}` : ''}`),
  review: (id: string, decision: 'approve' | 'decline' | 'acknowledge', note?: string) =>
    api.post<StudentRequest>(`/api/requests/${id}/review`, { decision, note: note ?? null }),
};
